import Box from "@mui/material/Box";
import mapboxgl from "mapbox-gl";
import React, { FC, useState } from "react";
import { useParams } from "react-router-dom";
import { ReserveTripMapRequest } from "../../api/models/ReserveTripMapRequest";
import { HermesSnackbar } from "../../components/snackbar";
import { initMap, retrieve } from "../../services/reserve/map";
import { store } from "../../store";
import { convertShiftDateToJpn, convertUTCtoJST } from "../../utils/formatting";

export const ReserveTripsMap: FC = () => {
    const newPk = useParams<{
        loginSessionId: string;
        unladenTripSessionId: string;
        unladenStartTs: string;
    }>();

    const [currentPk, update] = useState({});

    if (JSON.stringify(newPk) !== JSON.stringify(currentPk)) {
        // asyncブロックに入る前にPKを更新することでAPIの複数回の呼び出しを防ぐ
        update(newPk);
        retrieve(newPk);
        // console.debug("retrieve(reserveTripMapRequest)");
    }
    return <Map {...newPk}></Map>;
};

const Header: FC<ReserveTripMapRequest> = (props: ReserveTripMapRequest) => {
    const rtm = store.getState().reserveTripMap;
    const r = rtm.res;
    const v = rtm.isValid;
    const _shiftdate = v ? convertShiftDateToJpn(r.shiftStartDt) : "";
    const _drivercode = v ? r.driverCode : "";
    const _drivername = v ? r.driverName : "";
    const _unladenstart = v
        ? "空車開始時刻 " + convertUTCtoJST(props.unladenStartTs)
        : "";

    return (
        <Box style={{ padding: "10px" }}>
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <Box style={{ display: "flex" }}>
                    <Box style={{ padding: "20px" }}>{_shiftdate}</Box>
                    <Box style={{ padding: "20px" }}>
                        {_drivercode} {_drivername}
                    </Box>
                    <Box style={{ padding: "20px" }}>{_unladenstart}</Box>
                </Box>

                <Box
                    style={{
                        display: "flex",
                        alignItems: "center",
                        paddingRight: "40px",
                    }}
                ></Box>
            </Box>
        </Box>
    );
};

class Map extends React.Component<ReserveTripMapRequest> {
    constructor(props: any) {
        super(props);
    }

    mapContainer: string = "";
    map: mapboxgl.Map | undefined = undefined;

    shouldComponentUpdate = (nextProps, nextState): boolean => {
        this.map = initMap(this.mapContainer);
        // if (this.map === undefined) {
        //     this.map = initMap(this.mapContainer);
        // } else {
        //     this.map.triggerRepaint();
        //     // updateMap(this.map)
        // }

        return true;
    };

    render = () => {
        const v = store.getState().reserveTripMap.isValid;
        return (
            <Box
                id="Trips-Map-page-wrapper"
                sx={{
                    position: "static",
                    marginLeft: "30px",
                    width: "97%",
                }}
            >
                {
                    <HermesSnackbar
                        open={!v}
                        msg={v ? "" : "閲覧権限がありません。"}
                    />
                }
                <Header {...this.props} />
                <Box
                    id="Trips-Map-map-wrapper"
                    sx={{
                        display: "flex",
                        alignItems: "top",
                    }}
                >
                    <Box
                        id="Trips-Map-map-wrapper-inner"
                        sx={{
                            flexGrow: 2000,
                            left: "10px",
                            position: "relative",
                        }}
                    >
                        <Box
                            id="tripsMap"
                            sx={{
                                margin: "10px",
                                marginLeft: "15px",
                                minHeight: "800px",
                                width: "95%",
                                cursor: "pointer",
                            }}
                            ref={(el: string) => (this.mapContainer = el)}
                        />
                    </Box>
                </Box>
            </Box>
        );
    };
}
